import { z } from 'zod';

export const GROWTH_TILE_SLOT_KEY = 'growth.goal';
export const GROWTH_GOAL_TILE_TYPE = 'v1.growth.goal';
export const GROWTH_NEW_GOAL_TILE_TYPE = 'v1.growth.new-goal';

export const growthGoalTileSchema = z.object({
    goalId: z.string().regex(/^[\w-]+$/u),
    type: z.literal(GROWTH_GOAL_TILE_TYPE),
});

export const growthNewGoalTileSchema = z.object({
    recommendationId: z
        .string()
        .regex(/^[\w-]+$/u)
        .optional(),
    type: z.literal(GROWTH_NEW_GOAL_TILE_TYPE),
});

export type GrowthGoalTilePayload = z.infer<typeof growthGoalTileSchema>;
export type GrowthNewGoalTilePayload = z.infer<typeof growthNewGoalTileSchema>;

export const createGrowthGoalTilePayload = (goalId: string): GrowthGoalTilePayload => ({
    goalId,
    type: GROWTH_GOAL_TILE_TYPE,
});

export const createGrowthNewGoalTilePayload = (recommendationId?: string): GrowthNewGoalTilePayload => ({
    recommendationId,
    type: GROWTH_NEW_GOAL_TILE_TYPE,
});
